import { Pipe, PipeTransform } from '@angular/core';
import { areaUomAbbrev } from '@miq/utils';

@Pipe({
  name: 'abbrevUom',
  standalone: false,
})
export class AbbrevUomPipe implements PipeTransform {
  transform = areaUomAbbrev;
}
